import React, {useEffect, useState} from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEdit, faTrash} from '@fortawesome/free-solid-svg-icons';
import {axios} from "../../axios";
const CategoryItem = ({category,setCategories,handleStatus}) => {
    const [titleEn,setTitleEn] = useState('')
    const [titleDe,setTitleDe] = useState('')
    useEffect(()=>{
        setTitleEn(category.title_en)
        setTitleDe(category.title_de)
    },[category])
    const updateCategory = ()=>{
        handleStatus('load')
        const fd = new FormData()
        fd.append('title_en',titleEn)
        fd.append('title_de',titleDe)
        fd.append("_method", "put");
        axios.post(`/region/${category.id}`,fd)
            .then(res=>{
                handleStatus(res.data.message)
                setCategories(res.data.region)
            })
            .catch(()=>{
                handleStatus('error')
            })
    }
    const deleteCategory = ()=>{
        handleStatus('load')
        if(window.confirm(`Delete category ${titleEn}`)){
            axios.delete(`/region/${category.id}`)
                .then(res=>{
                    if(res.data.message === 'deleted'){
                        handleStatus('deleted')
                        setCategories(res.data.region)
                    }else {
                        handleStatus('error')
                    }
                }).catch(()=>{
                handleStatus('error')
                })
        }else{
            handleStatus('none')
        }
    }
    return (
        <div className='category-item align-items-center p-2 m-3 flex-column bg-white'>
            <p className='text-center'>
                {titleEn}
            </p>
            <div className='d-flex align-items-center'>
                <input value={titleEn} onChange={e=>setTitleEn(e.target.value)} type="text" className='me-1'/>
                <input value={titleDe} onChange={e=>setTitleDe(e.target.value)} type="text"/>
                <button className='edit-small-button me-2 ms-2' onClick={updateCategory}>
                    <FontAwesomeIcon icon={faEdit}/>
                </button>
                <button className='delete-small-button' onClick={deleteCategory}>
                    <FontAwesomeIcon icon={faTrash}/>
                </button>
            </div>

        </div>
    );
};

export default CategoryItem;